import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons"

export const PlayCircle = (props) => {
  return <FontAwesomeIcon faIcon={faPlayCircle} {...props} />
}
